import { action as addToCartPDPAction } from "./actions/tbsp-button-pdp-add-to-cart";
import { action as addToCartAction } from "./actions/tbsp-button-add-to-cart";
import { component } from "picoapp";
import { type Context } from "../../state";

const buttonActions = {
  "add-to-cart": addToCartAction,
  "pdp-add-to-cart": addToCartPDPAction,
  upsell: addToCartAction,
};

const isValidAction = (
  action: string | undefined
): action is keyof typeof buttonActions =>
  typeof action !== "undefined" && action in buttonActions;

export const button = component<Context>((node, context) => {
  const action = node.dataset.tbspAction;
  const target = node.dataset.tbspTarget;

  const clickHandler = (e: MouseEvent) => {
    if (isValidAction(action)) {
      void buttonActions[action](e);
    } else {
      context.emit("tbsp:button-clicked", { action, target });
    }
  };

  node.addEventListener("click", clickHandler);

  return (node: HTMLButtonElement) => {
    node.removeEventListener("click", clickHandler);
  };
});
